import { CaretRightIcon } from '@phosphor-icons/react';

import { SUPPORT_SENDER_LABEL } from '../constants';
import type { SupportTicketSummary } from '../types';

import styles from './support-ticket-row.module.scss';

export type SupportTicketRowProps = {
  ticket: SupportTicketSummary;
  onOpen: (id: string) => void;
};

/**
 * One listing row (Figma 2389-764730): title + last-message preview + chevron. An unread
 * ticket renders title + preview bold (story 101970 §3). The preview is prefixed with "Me:"
 * for a grower message, else the support sender label.
 */
export function SupportTicketRow({ ticket, onOpen }: SupportTicketRowProps) {
  const { lastMessage, unread } = ticket;
  const previewPrefix = lastMessage ? (lastMessage.fromGrower ? 'Me' : SUPPORT_SENDER_LABEL) : null;

  return (
    <button type="button" className={styles.row} onClick={() => onOpen(ticket.id)}>
      <span className={styles.text}>
        <span className={`${styles.title} ${unread ? styles.unread : ''}`}>{ticket.title}</span>
        {lastMessage ? (
          <span className={`${styles.preview} ${unread ? styles.unread : ''}`}>
            {previewPrefix}: {lastMessage.preview}
          </span>
        ) : null}
      </span>
      <CaretRightIcon size={18} weight="bold" className={styles.chevron} aria-hidden />
    </button>
  );
}
